/* Montela PDP v1 — size finder, cross-sell slider, customer-photo slider. No tracking, no external calls. */
(function () {
  if (window.__mmPdp) return; window.__mmPdp = true;
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function fmt(n) { return (Math.round(n * 10) / 10).toString(); }

  /* ---------- size finder ---------- */
  function Finder(root) {
    var cfgEl = $('[data-mm-sf-cfg]', root); if (!cfgEl) return;
    var C; try { C = JSON.parse(cfgEl.textContent); } catch (e) { return; }
    var T = C.t, conv = [];
    String(C.conv || '').split(',').forEach(function (p) { var k = p.trim().split(':'); if (k.length >= 2 && k[0]) conv.push({ eu: parseFloat(k[0]), us: k[1].trim(), uk: (k[2] || '').trim() }); });
    function usOf(eu) { for (var i = 0; i < conv.length; i++) if (conv[i].eu === eu) return conv[i].us; return ''; }
    /* second size system shown next to EU: AU for the Australia market (AU size names), US for other EN markets */
    var ALT = C.alt || (C.showUs ? 'US' : null), au = [];
    String(C.auConv || '').split(',').forEach(function (p) { var k = p.trim().split(':'); if (k.length >= 2 && k[0]) au.push({ eu: parseFloat(k[0]), v: k[1].trim() }); });
    function altList() { return ALT === 'AU' ? au.map(function (c) { return { eu: c.eu, v: c.v }; }) : conv.map(function (c) { return { eu: c.eu, v: c.us }; }); }
    function altOf(eu) { var l = altList(); for (var i = 0; i < l.length; i++) if (l[i].eu === eu) return l[i].v; return ''; }
    var A = {}, step = 0, dir = 1, unit = C.local ? 'us' : 'eu', modal, scope = root.closest('section, .shopify-section') || document;
    var STEPS = ['brand', 'size', 'width', 'instep', 'pref', 'prio', 'socks'];

    function sizeList() {
      if (unit === 'us') return altList().map(function (c) { return { label: ALT + ' ' + c.v, eu: c.eu }; });
      var out = []; for (var s = 35; s <= 46; s += 0.5) out.push({ label: loc(s), eu: s }); return out;
    }
    function opts(key, list) {
      var cls = key === 'size' ? ' mm-sf__opts--grid' : (key === 'brand' ? '' : ' mm-sf__opts--list');
      return '<div class="mm-sf__opts' + cls + '">' + list.map(function (o) {
        return '<button type="button" class="mm-sf__opt' + (A[key] === o.v ? ' is-on' : '') + '" data-k="' + key + '" data-v="' + esc(o.v) + '">' + esc(o.l) + '</button>';
      }).join('') + '</div>';
    }
    function body() {
      var k = STEPS[step], h = '';
      if (k === 'brand') h = '<p class="mm-sf__q">' + esc(T.q_brand) + '</p>' + opts('brand', C.brands.map(function (b) { return { v: b, l: b }; }).concat([{ v: 'other', l: T.brand_other }]));
      if (k === 'size') {
        var bn = A.brand === 'other' ? T.q_size_other : A.brand;
        h = '<p class="mm-sf__q">' + esc(T.q_size.replace('[brand]', bn)) + '</p>';
        if (ALT && altList().length) h += '<div class="mm-sf__unit"><button type="button" data-unit="eu" class="' + (unit === 'eu' ? 'is-on' : '') + '">' + esc(T.col_eu) + '</button><button type="button" data-unit="us" class="' + (unit === 'us' ? 'is-on' : '') + '">' + esc(ALT === 'AU' ? 'AU' : T.col_us) + '</button></div>';
        h += opts('size', sizeList().map(function (s) { return { v: String(s.eu), l: s.label }; }));
      }
      if (k === 'width') h = '<p class="mm-sf__q">' + esc(T.q_width) + '</p>' + opts('width', [{ v: 'narrow', l: T.w_narrow }, { v: 'normal', l: T.w_normal }, { v: 'wide', l: T.w_wide }]);
      if (k === 'instep') h = '<p class="mm-sf__q">' + esc(T.q_instep) + '</p>' + opts('instep', [{ v: 'yes', l: T.yes }, { v: 'no', l: T.no }]);
      if (k === 'pref') h = '<p class="mm-sf__q">' + esc(T.q_pref) + '</p>' + opts('pref', [{ v: 'snug', l: T.p_snug }, { v: 'normal', l: T.p_normal }, { v: 'roomy', l: T.p_roomy }]);
      if (k === 'prio') h = '<p class="mm-sf__q">' + esc(T.q_prio) + '</p>' + opts('prio', [{ v: 'toes', l: T.pr_toes }, { v: 'soft', l: T.pr_soft }, { v: 'easy', l: T.pr_easy }, { v: 'wide', l: T.pr_wide }, { v: 'none', l: T.pr_none }]);
      if (k === 'socks') h = '<p class="mm-sf__q">' + esc(T.q_socks) + '</p>' + opts('socks', [{ v: 'yes', l: T.yes }, { v: 'no', l: T.no }]);
      return h;
    }
    function calc() {
      var base = parseFloat(A.size), adj = 0, why = [T.r_base.replace('[size]', 'EU ' + loc(base))];
      if (C.fit === 'large') { adj -= 0.5; why.push(T.r_large); }
      if (C.fit === 'small') { adj += 0.5; why.push(T.r_small); }
      if (C.fit === 'narrow') why.push(T.r_narrow_model);
      if (A.width === 'wide') { adj += 0.5; why.push(T.r_wide); }
      if (A.width === 'narrow' && C.fit === 'large') { adj -= 0.5; why.push(T.r_narrow); }
      if (A.instep === 'yes') { adj += 0.25; why.push(T.r_instep); }
      if (A.pref === 'snug') { adj -= 0.5; why.push(T.r_snug); }
      if (A.pref === 'roomy') { adj += 0.5; why.push(T.r_roomy); }
      if (A.socks === 'yes') { adj += 0.25; why.push(T.r_socks); }
      /* priority step: only 'more room' wishes affect the size (small lean + larger size when between two sizes);
         'wide feet' is not counted twice if already chosen in the width step */
      var tie = C.tie;
      if (A.prio === 'toes' || (A.prio === 'wide' && A.width !== 'wide')) { adj += 0.25; tie = 'up'; why.push(T.r_prio_room); }
      else if (A.prio === 'wide') why.push(T.r_prio_wide_done);
      else if (A.prio === 'soft') why.push(T.r_prio_neutral.replace('[x]', T.pr_soft));
      else if (A.prio === 'easy') why.push(T.r_prio_neutral.replace('[x]', T.pr_easy));
      var t = base + adj, f = t - Math.floor(t), rec;
      if (Math.abs(f) < 1e-9) rec = t;
      else if (Math.abs(f - 0.5) < 1e-9) { rec = tie === 'down' ? Math.floor(t) : Math.ceil(t); if (tie === C.tie) why.push(tie === 'down' ? T.r_tie_down : T.r_tie_up); }
      else rec = f < 0.5 ? Math.floor(t) : Math.ceil(t);
      rec = Math.max(Math.ceil(base) - 1, Math.min(Math.floor(base) + 1, rec));
      return { eu: rec, why: why };
    }
    var SM = String(C.sizeMap || '').split('|').filter(Boolean).map(function (p) { var i = p.lastIndexOf('='); return { v: p.slice(0, i), eu: parseFloat(p.slice(i + 1)) }; });
    function findSizeValue(eu) { for (var i = 0; i < SM.length; i++) if (SM[i].eu === eu) return SM[i].v; return null; }
    function loc(n) { var s = fmt(n); return C.dec === ',' ? s.replace('.', ',') : s; }
    function currentColor() {
      if (C.colorIdx < 0) return null;
      var r = $$('input[type=radio]', scope).filter(function (i) { return i.name === C.colorName && i.checked; })[0];
      if (r) return r.value;
      var s = $$('select', scope).filter(function (x) { return x.name === 'options[' + C.colorName + ']'; })[0];
      return s ? s.value : null;
    }
    function available(val) {
      var col = currentColor();
      return C.variants.some(function (v) { return v.a && v.o[C.sizeIdx] === val && (col === null || C.colorIdx < 0 || v.o[C.colorIdx] === col); });
    }
    var lastRec = '';
    var recBox = $('[data-mm-sf-rec]', root);
    function showRec(label, val, save) {
      if (!recBox || !label) return;
      recBox.innerHTML = '<span class="mm-sf__rec-t"><span class="mm-sf__rec-l">' + esc(T.rec_label) + (/^fr/i.test(document.documentElement.lang || '') ? '\u00a0:' : ':') + '</span> <strong>' + esc(label) + '</strong></span><button type="button" class="mm-sf__rec-c" data-mm-sf-again>' + esc(T.rec_change) + '</button>';
      recBox.hidden = false;
      if (save) try { sessionStorage.setItem('mm_sf_' + C.handle, JSON.stringify({ l: label, v: val })); } catch (e) {}
    }
    try { var saved = JSON.parse(sessionStorage.getItem('mm_sf_' + C.handle) || 'null'); if (saved && saved.l) showRec(saved.l, saved.v, false); } catch (e) {}
    if (recBox) recBox.addEventListener('click', function (e) { if (e.target.closest('[data-mm-sf-again]')) open(); });
    function lab(v) { var f = window.mmSizeLabel || window.mmAuLabel, l = f && f(v); return l || v; } /* Montela 13 Oct: local (AU/US) display names */
    function result() {
      var r = calc(), val = findSizeValue(r.eu), us = ALT ? altOf(r.eu) : '', upNote = '';
      var size = (C.local && us) ? ALT + ' ' + us + ' (EU ' + loc(r.eu) + ')' : 'EU ' + loc(r.eu) + (us ? ' (' + ALT + ' ' + us + ')' : ''); /* local system first in AU/US/CA */
      if (!val && T.size_up) {
        var up = null;
        for (var u = 0; u < SM.length; u++) if (SM[u].eu > r.eu && (!up || SM[u].eu < up.eu)) up = SM[u];
        if (up) { val = up.v; upNote = T.size_up.replace('[size]', 'EU ' + loc(r.eu)).replace('[next]', lab(up.v)); size = lab(up.v); }
      }
      lastRec = size;
      var h = '<p class="mm-sf__q">' + esc(T.result_title) + '</p><div class="mm-sf__big"><span class="mm-sf__big-l">' + esc(T.rec_label) + '</span><span class="mm-sf__big-v">' + esc(size) + '</span></div><ul class="mm-sf__why">' + r.why.map(function (w) { return '<li>' + esc(w) + '</li>'; }).join('') + '</ul>';
      if (upNote) h += '<p class="mm-sf__warn">' + esc(upNote) + '</p>';
      if (!val) h += '<p class="mm-sf__warn">' + esc(T.not_offered.replace('[size]', 'EU ' + loc(r.eu))) + '</p>';
      else if (!available(val)) h += '<p class="mm-sf__warn">' + esc(T.unavailable.replace('[size]', lab(val))) + '</p>';
      else h += '<button type="button" class="mm-sf__cta" data-mm-sf-pick="' + esc(val) + '">' + esc(T.select_size.replace('[size]', lab(val))) + '</button>';
      h += '<p class="mm-sf__small">' + esc(T.r_note) + '</p><button type="button" class="mm-sf__link" data-mm-sf-restart>' + esc(T.restart) + '</button>';
      return h;
    }
    function render() {
      var done = step >= STEPS.length;
      $('.mm-sf__progress span', modal).style.width = (done ? 100 : (step / STEPS.length) * 100) + '%';
      $('.mm-sf__step', modal).textContent = done ? '' : T.step.replace('[n]', step + 1).replace('[t]', STEPS.length);
      var bd = $('.mm-sf__body', modal);
      bd.innerHTML = done ? result() : body();
      bd.classList.remove('is-in'); bd.classList.add(dir < 0 ? 'from-l' : 'from-r'); void bd.offsetWidth;
      bd.classList.add('is-in'); bd.classList.remove('from-l', 'from-r'); dir = 1;
      $('[data-mm-sf-back]', modal).hidden = step === 0;
      var f = $('.mm-sf__body button', modal); if (f) try { f.focus({ preventScroll: true }); } catch (e) {}
    }
    function pick(val) {
      var input = $$('input[type=radio]', scope).filter(function (i) { return i.name === C.sizeName && i.value === val; })[0];
      if (input) {
        var lab = input.id && scope.querySelector('label[for="' + input.id + '"]');
        if (lab) lab.click(); else { input.checked = true; input.dispatchEvent(new Event('change', { bubbles: true })); }
      } else {
        var s = $$('select', scope).filter(function (x) { return x.name === 'options[' + C.sizeName + ']'; })[0];
        if (s) { s.value = val; s.dispatchEvent(new Event('change', { bubbles: true })); }
      }
      showRec(lastRec, val, true);
      $('.mm-sf__body', modal).insertAdjacentHTML('afterbegin', '<p class="mm-sf__ok">' + esc(T.selected.replace('[size]', val)) + '</p>');
      setTimeout(close, 900);
    }
    var lastFocus;
    function open() {
      if (!modal) build();
      lastFocus = document.activeElement; step = 0; A = {}; unit = C.local ? 'us' : 'eu';
      modal.hidden = false; document.documentElement.classList.add('mm-sf-lock'); render();
    }
    function close() { if (!modal) return; modal.hidden = true; document.documentElement.classList.remove('mm-sf-lock'); if (lastFocus) try { lastFocus.focus(); } catch (e) {} }
    function build() {
      modal = document.createElement('div');
      modal.className = 'mm-sf-modal'; modal.hidden = true;
      modal.innerHTML = '<div class="mm-sf-modal__bg" data-mm-sf-close></div><div class="mm-sf-modal__box" role="dialog" aria-modal="true" aria-label="' + esc(T.finder_open) + '">' +
        '<div class="mm-sf-modal__top"><button type="button" class="mm-sf__nav" data-mm-sf-back>‹ ' + esc(T.back) + '</button><span class="mm-sf__step"></span><button type="button" class="mm-sf__x" data-mm-sf-close aria-label="' + esc(T.close) + '">×</button></div>' +
        '<p class="mm-sf-modal__title">' + esc(T.finder_open) + '</p><div class="mm-sf__progress"><span></span></div><div class="mm-sf__body"></div></div>';
      document.body.appendChild(modal);
      modal.addEventListener('click', function (e) {
        var t = e.target.closest('button, [data-mm-sf-close]'); if (!t) return;
        if (t.hasAttribute('data-mm-sf-close')) return close();
        if (t.hasAttribute('data-mm-sf-back')) { step = Math.max(0, step - 1); dir = -1; return render(); }
        if (t.hasAttribute('data-mm-sf-restart')) { step = 0; A = {}; return render(); }
        if (t.hasAttribute('data-mm-sf-pick')) return pick(t.getAttribute('data-mm-sf-pick'));
        if (t.hasAttribute('data-unit')) { unit = t.getAttribute('data-unit'); return render(); }
        var k = t.getAttribute('data-k'); if (!k) return;
        A[k] = t.getAttribute('data-v'); t.classList.add('is-on'); setTimeout(function () { step++; render(); }, 160);
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && modal && !modal.hidden) close(); });
    }
    var btn = $('[data-mm-sf-open]', root); if (btn) btn.addEventListener('click', open);
  }

  /* ---------- sliders (arrows) ---------- */
  function slider(root, trackSel) {
    var tr = $(trackSel, root), prev = $('[data-mm-xs-prev]', root), next = $('[data-mm-xs-next]', root);
    if (!tr || !prev || !next) return;
    function by(d) { var c = tr.firstElementChild; var w = c ? c.getBoundingClientRect().width + 10 : 200; tr.scrollBy({ left: d * w * Math.max(1, Math.floor(tr.clientWidth / w)), behavior: 'smooth' }); }
    function upd() { prev.disabled = tr.scrollLeft < 4; next.disabled = tr.scrollLeft + tr.clientWidth >= tr.scrollWidth - 4; root.classList.toggle('mm-xs--noscroll', tr.scrollWidth <= tr.clientWidth + 4); }
    prev.addEventListener('click', function () { by(-1); }); next.addEventListener('click', function () { by(1); });
    tr.addEventListener('scroll', upd, { passive: true }); window.addEventListener('resize', upd); upd();
  }

  /* ---------- cross-sell ---------- */
  function openCart() {
    var api = window.kachingCartApi;
    if (api && api.refreshCart) { try { var p = api.refreshCart(); var o = function () { try { api.openCart(); } catch (e) {} }; if (p && p.then) p.then(o, o); else o(); return; } catch (e) {} }
    var b = document.getElementById('cart-icon-bubble'); if (b) b.click(); else location.href = (window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart';
  }
  function add(card, id, btn, msgRoot) {
    var msg = $('[data-mm-xs-msg]', card); btn.disabled = true; msg.textContent = '';
    fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    }).then(function (r) { if (!r.ok) throw r; return r.json(); }).then(function () {
      msg.textContent = msgRoot.getAttribute('data-added'); btn.disabled = false; openCart(); if (msgRoot.__mmRefresh) setTimeout(msgRoot.__mmRefresh, 300);
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    }).catch(function () { msg.textContent = msgRoot.getAttribute('data-error'); btn.disabled = false; });
  }

  /* ---------- Mix & Match price on cross-sell cards (same rule as the automatic discount: % per pair on every pair,
     per unit truncated to the cent; pairs = shoes in the cart, accessories/gifts excluded; + the pair being added) ---------- */
  function fmtMoney(cents, f) {
    /* f = shop.money_with_currency_format from Liquid (market-aware, e.g. '{{amount_with_comma_separator}} DKK') */
    var mmCur = window.Shopify && Shopify.currency && Shopify.currency.active;
    f = f || '{{amount}}';
    /* Montela: EUR plain (€49,95), every other currency with ISO code */
    if (mmCur === 'EUR') f = f.replace(/\s*EUR\s*$/, '');
    function fmt(n, dec, th, ds) { if (Math.round(n) % 100 === 0) dec = 0; var p = (n / 100).toFixed(dec).split('.'); p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, th); return p.length > 1 ? p[0] + ds + p[1] : p[0]; }
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      switch (k) {
        case 'amount_no_decimals': return fmt(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return fmt(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return fmt(cents, 2, "'", '.');
        case 'amount_with_space_separator': return fmt(cents, 2, ' ', ',');
        default: return fmt(cents, 2, ',', '.');
      }
    }).replace(/<[^>]*>/g, '');
  }
  /* Montela 14 Oct: cart-aware tiers. pairs = shoe pairs already in the cart (0-price/gift lines and accessories excluded).
     0 → price of a 2nd pair (tier 2) + "from the 2nd pair"; 1 → tier 2 "as 2nd pair"; 2 → tier 3 "as 3rd pair"; 3+ → highest tier. */
  function mmTier(pairs, tiers) {
    var n = Math.max(pairs + 1, 2), p = 0; tiers.forEach(function (t) { if (n >= t.n) p = t.p; });
    return { p: p, i: Math.min(pairs, 3) };
  }
  function mmEff(price, p) { return price - Math.floor(price * p / 100 + 1e-9); } /* discount per unit truncated to the cent (= Kaching cart) */
  function mmCountPairs(c, isPair) {
    var n = 0; (c && c.items || []).forEach(function (i) {
      if (!(i.price > 0) || !(i.final_price > 0)) return; /* free gifts / 0-price lines */
      if (isPair(i.product_type, i.handle, i.properties)) n += i.quantity;
    }); return n;
  }
  window.__mmXsTest = { tier: mmTier, eff: mmEff, count: mmCountPairs, fmt: fmtMoney };
  /* notify the cross-sell when anything talks to /cart endpoints (fetch + XHR); installed once */
  (function hookCart() {
    if (window.__mmCartHook) return; window.__mmCartHook = 1;
    var re = /\/cart(\/(add|change|update|clear)(\.js)?|\.js)(\?|$)/, own = /cart\.js\?mmx/;
    function ping(u) { try { u = String(u && u.url || u || ''); if (re.test(u) && !/\/cart\.js(\?|$)/.test(u) && !own.test(u)) setTimeout(function () { document.dispatchEvent(new CustomEvent('mm:cart-request')); }, 0); } catch (e) {} }
    if (window.fetch) { var f = window.fetch; window.fetch = function (u) { var r = f.apply(this, arguments); ping(u); if (r && r.then) r.then(function () { ping(u); }, function () {}); return r; }; }
    var X = window.XMLHttpRequest && XMLHttpRequest.prototype, op = X && X.open;
    if (op) X.open = function (m, u) { var x = this; try { x.addEventListener('loadend', function () { ping(u); }); } catch (e) {} return op.apply(this, arguments); };
  })();
  function MMPrice(root) {
    /* 2026-11-02 Offer A rollout: offer-aware card labels (cfg from snippets/mm-crosssell, v2).
       A (default): label with the fixed bundle prices (2 pairs [x] / 3 pairs [y]), card price unchanged.
       B (html[data-offer=b]): 2nd pair −15 % painted on the card (same rounding as ot.js: discount rounded half-up), 3rd pair label only (cheapest pair −50 %).
       The old Mix & Match tiers (−15 % / −25 %) are gone. Backup: /workspace/sticky/backup2/assets/mm-pdp.js */
    var ofr = (window.MT_OFFER && window.MT_OFFER.offer) || document.documentElement.getAttribute('data-offer') || 'a';
    ofr = ofr === 'b' ? 'b' : 'a';
    var el = $('[data-mm-xs-cfg]', root); if (!el) return;
    var C; try { C = JSON.parse(el.textContent); } catch (e) { return; }
    var labels = (ofr === 'b' ? C.b : C.a) || [];
    if (!labels.length) return;
    var bPct = C.bPct || [0, 15, 0, 0];
    var G = window.MM || {}, exT = (G.exTypes || []).concat(C.exTypes || []), exK = (G.exKeys || []).concat(C.exKeys || []);
    function isPair(type, handle, props) {
      if (props && props._kaching_cart) return false;
      if (exT.indexOf((type || '').toLowerCase()) > -1) return false;
      handle = (handle || '').toLowerCase();
      for (var i = 0; i < exK.length; i++) if (handle.indexOf(exK[i]) > -1) return false;
      return true;
    }
    function paint(pairs) {
      var i = Math.min(Math.max(pairs, 0), 3);
      $$('[data-mm-xs-price]', root).forEach(function (pe) {
        var card = pe.closest('[data-mm-xs-card]'), lab = $('[data-mm-xs-mm]', card);
        if (!pe.__orig) pe.__orig = pe.innerHTML;
        var price = parseInt(pe.getAttribute('data-price'), 10);
        if (!(price > 0) || !isPair(pe.getAttribute('data-type'), pe.getAttribute('data-handle'))) { pe.innerHTML = pe.__orig; if (lab) lab.hidden = true; return; }
        var p = ofr === 'b' ? (bPct[i] || 0) : 0;
        if (p > 0) {
          var eff = price - Math.round(price * p / 100);
          pe.innerHTML = '<span class="mm-xs__now">' + esc(fmtMoney(eff, C.fmt)) + '</span><s class="mm-xs__was">' + esc(fmtMoney(price, C.fmt)) + '</s>';
        } else if (pe.innerHTML !== pe.__orig) { pe.innerHTML = pe.__orig; }
        if (lab) { lab.textContent = labels[i] || ''; lab.hidden = !labels[i]; }
      });
    }
    var busy = false, again = false;
    function refresh() {
      if (busy) { again = true; return; } busy = true;
      fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart.js?mmx=1', { cache: 'no-store', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { var n = mmCountPairs(c, isPair); root.setAttribute('data-pairs', n); paint(n); })
        .catch(function () {})
        .then(function () { busy = false; if (again) { again = false; setTimeout(refresh, 300); } });
    }
    var t, t2; function soon() { clearTimeout(t); clearTimeout(t2); t = setTimeout(refresh, 400); t2 = setTimeout(refresh, 1600); }
    ['cart:updated', 'cart:refresh', 'cart:change', 'kaching-cart:updated', 'mm:cart'].forEach(function (ev) { document.addEventListener(ev, soon); });
    document.addEventListener('mm:cart-request', soon);
    try { new PerformanceObserver(function (l) { l.getEntries().forEach(function (e) { if (/\/cart(\/(add|change|update|clear)|\.js)/.test(e.name) && !/cart\.js\?mmx/.test(e.name)) soon(); }); }).observe({ type: 'resource', buffered: false }); } catch (e) {}
    function watchDrawer() { var k = document.getElementById('kaching-cart'); if (!k) return setTimeout(watchDrawer, 800); new MutationObserver(soon).observe(k, { attributes: true, subtree: true, attributeFilter: ['open'] }); }
    watchDrawer();
    try { var bub = document.getElementById('cart-icon-bubble'); if (bub) new MutationObserver(soon).observe(bub, { childList: true, subtree: true, characterData: true }); } catch (e) {}
    document.addEventListener('visibilitychange', function () { if (!document.hidden) soon(); });
    root.__mmRefresh = refresh;
    refresh();
    window.addEventListener('load', soon);
  }
  function CrossSell(root) {
    slider(root, '[data-mm-xs-track]');
    MMPrice(root);
    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-mm-xs-add], [data-mm-xs-confirm]'); if (!b) return;
      var card = b.closest('[data-mm-xs-card]');
      if (b.hasAttribute('data-mm-xs-confirm')) { var s = $('[data-mm-xs-select]', card); if (s.value) add(card, s.value, b, root); return; }
      var v = b.getAttribute('data-variant');
      if (v) return add(card, v, b, root);
      var pk = $('[data-mm-xs-pick]', card); if (pk) { pk.hidden = false; b.hidden = true; var sel = $('select', pk); try { sel.focus(); } catch (e2) {} }
    });
    root.addEventListener('change', function (e) {
      var s = e.target.closest('[data-mm-xs-select]'); if (!s) return;
      $('[data-mm-xs-confirm]', s.closest('[data-mm-xs-card]')).disabled = !s.value;
    });
  }

  /* ---------- customer photos: move under the buy buttons ---------- */
  /* customer photos: optional slow continuous auto-scroll (seamless loop by duplicating the cards) */
  function Marquee(root) {
    var speed = parseFloat(root.getAttribute('data-autoscroll'));
    if (!speed || root.__mq) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var track = $('.mm-ugc__track', root); if (!track) return;
    var orig = $$('.mm-ugc__card', track);
    function setW() { var a = orig[0], b = orig[orig.length - 1]; return b.offsetLeft + b.offsetWidth + parseFloat(getComputedStyle(b).marginRight || 0) + 12 - a.offsetLeft; }
    if (!orig.length || setW() <= track.clientWidth + 12) return; /* everything fits: no motion */
    root.__mq = 1;
    orig.forEach(function (c) { var k = c.cloneNode(true); k.setAttribute('aria-hidden', 'true'); k.removeAttribute('data-shopify-editor-block'); $$('img', k).forEach(function (i) { i.alt = ''; }); track.appendChild(k); });
    orig[orig.length - 1].style.marginRight = '12px';
    root.classList.add('mm-ugc--auto');
    var pos = track.scrollLeft, last = 0, paused = false, resumeT = 0, W = setW();
    function pause() { paused = true; clearTimeout(resumeT); }
    function resume(delay) { clearTimeout(resumeT); resumeT = setTimeout(function () { pos = track.scrollLeft; paused = false; }, delay || 0); }
    track.addEventListener('mouseenter', pause);
    track.addEventListener('mouseleave', function () { resume(300); });
    track.addEventListener('touchstart', pause, { passive: true });
    track.addEventListener('touchend', function () { resume(2500); }, { passive: true });
    track.addEventListener('pointerdown', pause);
    track.addEventListener('focusin', pause);
    track.addEventListener('focusout', function () { resume(1500); });
    track.addEventListener('scroll', function () { if (paused) { if (track.scrollLeft >= W) track.scrollLeft -= W; } }, { passive: true });
    window.addEventListener('resize', function () { W = setW(); });
    function tick(t) {
      if (!root.isConnected) return;
      var dt = last ? Math.min(64, t - last) : 0; last = t;
      if (!paused && !document.hidden) {
        pos += speed * dt / 1000;
        if (pos >= W) pos -= W;
        track.scrollLeft = pos;
      }
      requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }

  function Ugc(root) {
    /* target: bottom of the product info column, directly below the USP / trust badges; fallback: old slot under the buy buttons */
    var info = document.querySelector('.product__info-container');
    var badges = info && info.querySelector('.montela-trust-badges');
    var slot = null;
    if (badges) {
      var blk = badges; while (blk.parentElement && blk.parentElement !== info) blk = blk.parentElement;
      slot = info.querySelector('[data-mm-ugc-slot2]');
      if (!slot) { slot = document.createElement('div'); slot.setAttribute('data-mm-ugc-slot2', ''); slot.className = 'mm-ugc-slot2'; }
      if (blk.nextElementSibling !== slot) blk.parentNode.insertBefore(slot, blk.nextSibling);
    } else slot = document.querySelector('[data-mm-ugc-slot]');
    var sec = root.closest('.shopify-section') || root;
    if (slot && !slot.contains(root)) {
      /* theme editor re-renders the section: drop previously moved copies so there is never a duplicate */
      $$('[data-mm-ugc-slot] [data-mm-ugc], [data-mm-ugc-slot2] [data-mm-ugc]').forEach(function (o) { if (o !== root) o.remove(); });
      slot.appendChild(root);
    }
    if (sec !== root && !sec.querySelector('[data-mm-ugc]')) sec.classList.add('mm-ugc-moved');
    Marquee(root);
  }

  /* typography: mirror the theme/app 'Größe' variant label (computed at runtime, so it follows theme/app changes) */
  function syncLabelFont() {
    var cands = document.querySelectorAll('variant-swatch-king label.swatch-label, label.swatch-label, .product-form__input .form__label, variant-radios legend, variant-selects label.form__label');
    var L = null;
    for (var i = 0; i < cands.length; i++) { if (cands[i].offsetParent && cands[i].textContent.trim()) { L = cands[i]; break; } }
    if (!L) return false;
    var c = getComputedStyle(L), r = document.documentElement.style;
    r.setProperty('--mm-lbl-ff', c.fontFamily); r.setProperty('--mm-lbl-fw', c.fontWeight);
    r.setProperty('--mm-lbl-fs', c.fontSize); r.setProperty('--mm-lbl-ls', c.letterSpacing === 'normal' ? 'normal' : c.letterSpacing);
    r.setProperty('--mm-lbl-fst', c.fontStyle); r.setProperty('--mm-lbl-tt', c.textTransform);
    return true;
  }
  (function trySync(n) { if (!syncLabelFont() && n < 40) setTimeout(function () { trySync(n + 1); }, 250); else if (n < 40) setTimeout(syncLabelFont, 1500); })(0);
  window.addEventListener('resize', function () { clearTimeout(window.__mmLblT); window.__mmLblT = setTimeout(syncLabelFont, 200); });

  function init(scope) {
    $$('[data-mm-sf]', scope).forEach(function (r) { if (r.__mm) return; r.__mm = 1; Finder(r); });
    $$('[data-mm-xs]', scope).forEach(function (r) { if (r.__mm) return; r.__mm = 1; CrossSell(r); });
    $$('[data-mm-ugc]', scope).forEach(function (r) { if (r.__mm) return; r.__mm = 1; Ugc(r); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); }); else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:unload', function (e) { if (e.target && e.target.querySelector && e.target.classList.contains('mm-ugc-section')) { $$('[data-mm-ugc-slot] [data-mm-ugc], [data-mm-ugc-slot2] [data-mm-ugc]').forEach(function (o) { o.remove(); }); } });
})();
